export default __webpack_public_path__ + "static/media/cdmCases.22bc4110.png";